enum FeatureFlags {
    ENTITIES_OVERVIEW_LINK_ENABLED = 'entities-overview-link-enabled',
    TELEMETRY_EXPORTER_CLASSIC_UI_SIDE_NAV_LINK_ENABLED = 'telemetry-exporter-classic-ui-side-nav-link-enabled',
    TRACES_OVERVIEW_CLASSIC_UI_SIDE_NAV_LINK_ENABLED = 'traces-overview-classic-ui-side-nav-link-enabled',
    API_ANALYTICS_BUILT_IN_DASHBOARD_DISABLED = 'api-analytics-built-in-dashboard-disabled',
    BUILT_IN_DASHBOARDS_SKIP_LOADING_RESOURCES_ENABLED = 'built-in-dashboards-skip-loading-resources-enabled',
    DEFER_LABELS_CALL_IN_LANDING_PAGE_ENABLED = 'defer-labels-call-in-landing-page-enabled',
    MONITORING_CENTER_MPKI_CERTS_EXPIRY_BANNER_ENABLED = 'monitoring-center-mpki-certs-expiry-banner-enabled',
    ALERTS_BASIC_ADVANCED_FILTER_ENABLED = 'alerts-basic-advanced-filter-enabled',
    ALERTS_TYPE_FILTER_BANNER_ENABLED = 'alerts-type-filter-banner-enabled'
}

export default FeatureFlags;
